import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Alert, OverlaySpinner } from '@insurancemenu/imenu-components-lib';
import SectionTitle from 'components/common/general/SectionTitle';
import FavoriteProposalStepController from 'store/modules/initiate-quote/favoriteProposalStepController';
import { FAVORITE_QUOTE_STEP_TEST_ID, INITIATE_PROPOSAL_FAVORITE_FORM_ID } from '../constants';
import { ContentStyled } from './styles';
import FavoriteProposalsView from './FavoriteProposalsView';
import NoFavoriteProposalsView from './NoFavoriteProposalsView';
import { TabIMFormStyled } from '../styles';

interface Props {
  favoriteProposalStepController: FavoriteProposalStepController;
}

const StepContent: React.FC<Props> = observer(({ favoriteProposalStepController }) => {
  const hasFavoriteProposals = favoriteProposalStepController.favoriteProposalOptions.length > 0;

  return (
    <>
      {hasFavoriteProposals ? (
        <FavoriteProposalsView favoriteProposalStepController={favoriteProposalStepController} />
      ) : (
        <NoFavoriteProposalsView favoriteProposalStepController={favoriteProposalStepController} />
      )}
      <Alert
        type="info"
        content={[
          <span key="0">
            <b>Note: </b>
            Creating a proposal from a favorite doesn&apos;t finalize your selections—it provides a starting point. You
            can modify the browsing criteria, product lines and selected plans throughout the proposal initiation
            process.
          </span>,
        ]}
      />
    </>
  );
});

const FavoriteQuoteStep: React.FC<Props> = observer(({ favoriteProposalStepController }) => {
  const { form, isActionLoading, fetchFavoriteProposals } = favoriteProposalStepController;

  useEffect(() => {
    void fetchFavoriteProposals();
  }, []);

  return (
    <TabIMFormStyled
      id={INITIATE_PROPOSAL_FAVORITE_FORM_ID}
      formController={form}
      data-test-id={FAVORITE_QUOTE_STEP_TEST_ID}
    >
      <SectionTitle
        title="Reuse a Favorite Proposal"
        subtitle="Choose the favorite proposal you'd like to use as the starting point for your new proposal"
      />
      <ContentStyled>
        {isActionLoading ? (
          <OverlaySpinner display />
        ) : (
          <StepContent favoriteProposalStepController={favoriteProposalStepController} />
        )}
      </ContentStyled>
    </TabIMFormStyled>
  );
});

export default FavoriteQuoteStep;
